import * as React from 'react';

interface ToggleSwitchProps {
  id: string;
  label: string;
  checked: boolean;
  onChange: () => void;
}

// Labeled on/off switch used in the nav menu (Dark Mode, Falling effects).
export const ToggleSwitch = ({ id, label, checked, onChange }: ToggleSwitchProps) => (
  <div className="flex items-center justify-between text-sm text-gray-700 mb-2">
    <label htmlFor={id} className="cursor-pointer">
      <strong>{label}</strong>
    </label>
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={`Toggle ${label.toLowerCase()}`}
      onClick={onChange}
      className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4f9dff] focus-visible:ring-offset-2 dark:focus-visible:ring-offset-[#171b22] ${
        checked ? 'bg-[#4f9dff]' : 'bg-[#cbd5e1]'
      }`}
    >
      <span
        className={`inline-block h-5 w-5 rounded-full bg-[#ffffff] shadow transition-transform ${
          checked ? 'translate-x-[22px]' : 'translate-x-[2px]'
        }`}
      />
    </button>
  </div>
);
